module.exports = __webpack_public_path__ + "img/puzzle_37.bf2e2b8a.png";